import React, { useState, createContext } from "react";

type UsecaseContextType = {
  usecaseData: any;
  updateUsecaseData: (newdata: any) => void;
  savingMetaData: any;
  updateSavingMetaData: (newdata: any) => void;
  standardField: any;
  updateStandardField: (newdata: any) => void;
  modelData: any;
  updateModelData: (newdata: any) => void;
  modelList: any;
  updateModelList: (newdata: any) => void;
  allEvents: any;
  updateAllEvents: (newdata: any) => void;
  allLogSource: any;
  updateAllLogSource: (newdata: any) => void;
  AnomalyData: any;
  updateAnomalyData: (newdata: any) => void;
  FieldData: any;
  updateFieldData: (newdata: any) => void;
  SearchList: any;
  updateSearchList: (newdata: any) => void;
  CurrentView: string;
  updateCurrentView: (newdata: string) => void;
  DefeatData: any;
  updateDefeatData: (newdata: any) => void;
  DefeatMappingData: any;
  updateDefeatMappingData: (newdata: any) => void;
  UserMappingData: any;
  updateUserMappingData: (newdata: any) => void;
  AnomalyEventType: string;
  updateAnomalyEventType: (newdata: string) => void;
  metaMapping: any;
  updateMetaMapping: (newdata: any) => void;
  eventOrder: string[];
  updateEventOrder: (newdata: string[]) => void;
  editable: boolean;
  updateEditable: (newdata: boolean) => void;
};

export const UsecaseContext = createContext<UsecaseContextType>({
  usecaseData: {},
  updateUsecaseData: () => {},
  savingMetaData: {},
  updateSavingMetaData: () => {},
  standardField: [],
  updateStandardField: () => [],
  modelData: [],
  updateModelData: () => {},
  modelList: [],
  updateModelList: () => {},
  allEvents: [],
  updateAllEvents: () => {},
  allLogSource: [],
  updateAllLogSource: () => {},
  AnomalyData: {},
  updateAnomalyData: () => {},
  FieldData: [],
  updateFieldData: () => {},
  SearchList: [],
  updateSearchList: () => {},
  CurrentView: "",
  updateCurrentView: () => {},
  DefeatData: {},
  updateDefeatData: () => {},
  DefeatMappingData: {},
  updateDefeatMappingData: () => {},
  UserMappingData: {},
  updateUserMappingData: () => {},
  AnomalyEventType: "",
  updateAnomalyEventType: () => {},
  metaMapping: {},
  updateMetaMapping: () => {},
  eventOrder: [],
  updateEventOrder: () => {},
  editable: true,
  updateEditable: () => {},
});

export const UsecaseProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const structure = {
    block_list: [
      {
        group_list: [],
        group_ids: [],
        block_id: "1",
        block_cond: "AND",
        log_source: { name: "", value: "" },
        threshold_conditions: {},
      },
    ],
    eventBasicDetails: {
      eventIsActive: false,
      eventScore: "6",
      eventDeduplication: {},
      eventName: "",
      eventIsDeleted: false,
      eventDisplayFields: [],
      eventIsPrivate: false,
      eventDesc: "",
    },
    event_log_mapping: {
      event_field: {
        type: "",
        name: "",
        label: "",
      },
      event_type: "",
    },
    block_ids: {
      "1": "1",
    },
  };

  const anomalyStructure = {
    event_list: {},
    event_ids: [],
    EventsTimeOrder: false,
    ruleBasicDetails: {
      ruleCategory: "",
      ruleDesc: "",
      ruleIsActive: false,
      // ruleIsAnomaly: false,
      ruleIsPrivate: false,
      ruleMitreCategory: [],
      ruleMitreTechnique: "",
      ruleName: "",
      ruleScore: "6",
      ruleTcpReset: false,
      ruleDisplayFields: [],
      ruleIsDeleted: false,
      ruleAnomalyFlag: 1,
      ruleResolution: "",
      ruleMitreDefendTechnique: [],
      external_functions: {},
    },
  };

  const defeatData = {
    includeMeta: [],
    excludeMeta: [],
    includeDevice: [],
    excludeDevice: [],
  };

  const [usecaseData, setusecaseData] = useState(structure);
  const [savingMetaData, setSavingMetaData] = useState(structure);
  const [standardField, setStandardField] = useState([]);
  const [modelData, setModelData] = useState([] as any);
  const [modelList, setModelList] = useState([] as any);
  const [allEvents, setAllEvents] = useState([] as any);
  const [allLogSource, setAllLogSource] = useState([] as any);
  const [AnomalyData, setAnomalyData] = useState(anomalyStructure);
  const [FieldData, setFieldData] = useState([] as any);
  const [SearchList, setSearchList] = useState([] as any);
  const [CurrentView, setCurrentView] = useState("");
  const [DefeatData, setDefeatData] = useState(defeatData);
  const [DefeatMappingData, setDefeatMappingData] = useState([] as any);
  const [UserMappingData, setUserMappingData] = useState([] as any);
  const [AnomalyEventType, setAnomalyEventType] = useState("");
  const [metaMapping, setMetaMapping] = useState([] as any);
  const [eventOrder, setEventOrder] = useState<string[]>([]);
  const [editable, setEditable] = useState(true);

  const updateUsecaseData = (newdata: any) => {
    if (Object.keys(newdata).length == 0) {
      setusecaseData(structure);
    } else {
      setusecaseData(newdata);
    }
  };

  const updateSavingMetaData = (newdata: any) => {
    setSavingMetaData(newdata);
  };

  const updateStandardField = (newdata: any) => {
    setStandardField(newdata);
  };

  const updateModelData = (newdata: any) => {
    setModelData(typeof newdata === "function" ? newdata : newdata);
  };

  const updateModelList = (newdata: any) => {
    setModelList(newdata);
  };

  const updateAllEvents = (newdata: any) => {
    setAllEvents(newdata);
  };

  const updateAllLogSource = (newdata: any) => {
    setAllLogSource(newdata);
  };

  const updateAnomalyData = (newdata: any) => {
    if (Object.keys(newdata).length == 0) {
      setAnomalyData(anomalyStructure);
    } else {
      setAnomalyData(newdata);
    }
  };

  const updateFieldData = (newdata: any) => {
    setFieldData(newdata);
  };

  const updateSearchList = (newdata: any) => {
    setSearchList(newdata);
  };

  const updateCurrentView = (newdata: string) => {
    setCurrentView(newdata);
  };

  const updateDefeatData = (newdata: any) => {
    setDefeatData(newdata);
  };

  const updateDefeatMappingData = (newdata: any) => {
    setDefeatMappingData(newdata);
  };

  const updateUserMappingData = (newdata: any) => {
    setUserMappingData(newdata);
  };

  const updateAnomalyEventType = (newdata: string) => {
    setAnomalyEventType(newdata);
  };

  const updateMetaMapping = (newdata: any) => {
    setMetaMapping(newdata);
  };

  const updateEventOrder = (newdata: string[]) => {
    setEventOrder(newdata);
  };

  const updateEditable = (newdata: boolean) => {
    setEditable(newdata);
  };

  return (
    <UsecaseContext.Provider
      value={{
        usecaseData,
        updateUsecaseData,
        savingMetaData,
        updateSavingMetaData,
        standardField,
        updateStandardField,
        modelData,
        updateModelData,
        modelList,
        updateModelList,
        allEvents,
        updateAllEvents,
        allLogSource,
        updateAllLogSource,
        AnomalyData,
        updateAnomalyData,
        FieldData,
        updateFieldData,
        SearchList,
        updateSearchList,
        CurrentView,
        updateCurrentView,
        DefeatData,
        updateDefeatData,
        DefeatMappingData,
        updateDefeatMappingData,
        UserMappingData,
        updateUserMappingData,
        AnomalyEventType,
        updateAnomalyEventType,
        metaMapping,
        updateMetaMapping,
        eventOrder,
        updateEventOrder,
        editable,
        updateEditable,
      }}
    >
      {children}
    </UsecaseContext.Provider>
  );
};
